import styled from 'styled-components';
import Button from '@catalogo/ui-americanas-desktop-button';

interface ITermNotFound {
  isDesk?: boolean;
}

const Wrapper = styled.div<ITermNotFound>`
  padding-left: ${({ isDesk }) => (isDesk ? '8px' : '')};
  text-align: left;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: #666666;
  margin-bottom: 20px;
`;

const Message = styled.div<ITermNotFound>`
  font-size: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
  color: #666666;
  margin: 15px 0;
`;

const List = styled.ul<ITermNotFound>`
  margin: 4px 0 15px 8px;

  > li {
    font-size: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
    line-height: 20px;
    list-style: disc;
    list-style-position: inside;
    margin-bottom: 8px;
  }
`;
const ButtonDeskUI = styled(Button)`
  color: ${({ theme }) => theme.primaryColor};
  justify-content: flex-start;
  background: #ffff;
  border-radius: 8px;
  font-size: 18px;
  text-transform: ${({ theme }) => theme.btnTextTransform};
  width: 232px;
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;
  margin-left: 28px;
  margin-bottom: 12px;
`;

export { Wrapper, Message, List, ButtonDeskUI };
